import { render, staticRenderFns } from "./IconChatSolid.vue?vue&type=template&id=29b2aa97"
import script from "./IconChatSolid.vue?vue&type=script&lang=js"
export * from "./IconChatSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports